export const IMAGE_TYPE = {
  AWS_S3: 's3',
  CANVA: 'canva',
  EBAY: 'ebayimg',
  ETSY: 'etsy',
  LOCAL: 'local',
  SHOPIFY: 'shopify',
  UNSPLASH: 'unsplash',
};
